import { call, put, takeLatest } from "redux-saga/effects";

import { PatientsAPI } from "../../../api/patientsAPI";
import {
  GET_PATIENT_MEDICATIONS_REQUEST,
  GET_PATIENT_MEDICATIONS_SUCCESS,
  GET_PATIENT_MEDICATIONS_ERROR
} from "../../actions";

function* workerGetPatientMedications({
  type,
  payload: { patientId, startDate, endDate },
}: {
  type: string;
  payload: {
    patientId: any;
    startDate: string;
    endDate?: string;
  };
}): Generator<any> {
  try {
    const data: any = yield call(PatientsAPI.getPatientMedications, patientId, startDate, endDate);

    yield put({
      type: GET_PATIENT_MEDICATIONS_SUCCESS,
      payload: { currentMedications: data }
    });
  } catch (error: any) {
    yield put({
      type: GET_PATIENT_MEDICATIONS_ERROR,
      payload: { code: error.response.status, message: error.message }
    });
  }
}

export function* watcherGetPatientMedications() {
  yield takeLatest(GET_PATIENT_MEDICATIONS_REQUEST, workerGetPatientMedications);
}
